module.exports = __webpack_public_path__ + "static/img/logo_mut.eed25e8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo_mut.jpg
// module id = 1W8L
// module chunks = 2